import { SwxTheme } from 'swx-atomic-component-lib'

const collaborateTheme = `
  padding: 0 2rem;

  * {
    font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, ".SFNSText-Regular", sans-serif;
  }

  input {
    border-radius: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.28572;
    letter-spacing: 0.16px;
    outline: 2px solid transparent;
    outline-offset: -2px;
    width: 100%;
    height: 2.5rem;
    border: none;
    padding: 0 1rem;
    border-bottom: 1px solid black;
    background-color: #f4f4f4;
    color: #161616;
    font-family: inherit;
    transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9),
    outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  }

  input:active {
    outline: 2px solid #0f62fe;
    outline-offset: -2px;
  }

  input:focus {
    color: unset;
    box-shadow: unset;
    outline: 2px solid #0f62fe;
    outline-offset: -2px;
  }

  input::placeholder {
    color: rgba(22, 22, 22, 0.4);
    opacity: 1;
  }

  input:not(:focus).error {
    outline: 2px solid #da1e28;
    outline-offset: -2px; 
  }

  input.error{
    padding-right: 2.5rem;
  }

  .field-label {
    font-size: .75rem;
    letter-spacing: .32px;
    display: inline-block;
    margin-bottom: 0.35rem;
    color: #525252;
    font-weight: 400;
    line-height: 1rem;
    vertical-align: baseline;
  }

  .field-container {
    margin-bottom: 1rem;
  }

  .field-container-p {
    padding-bottom: 1rem;
  }

  .weak-label {
    width: 50%;
    font-size: 0.75rem;
    color: rgb(22, 22, 22);
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0;
    margin-top: -4px;
  }

  .strong-label {
    width: 50%;
    font-size: 0.75rem;
    color: rgb(22, 22, 22);
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0;
    margin-top: -4px;
    text-align: right;
  }

  .suggestion-label{
    margin-bottom: 0.5rem;
    color: rgb(198, 198, 198);
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0;
  }

  .pass-error {
    svg {
    right: 2.5rem;
    position: absolute;
    fill: #da1e28;
    transform: translateY(-50%);
    height: 16px;
    width: 16px;
  }
}

  .toggle-style {
    opacity: 1;
    height: 40px;
    width: 40px;
    padding-top: 5px;
    right: 0;

    svg {
      margin-top: -3px;
    }

    &:focus {
      outline: 2px solid #0f62fe;
      outline-offset: -2px;
    }
  }

  .captcha {
    margin-top: 1rem;
  }

  .links {
      margin-left: 1.56rem;
    & > a {
      margin-right: 1.625rem;
      cursor: pointer;
      color: #0f62fe;
      font-size: 0.875rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: 0.16px;
      text-decoration: none;
    }
  }

  .sign-in-container {
    margin-bottom: 1.5rem;
    font-size: 0.875rem;
    line-height: 1.43;
    letter-spacing: 0.16px;
  
    & > span {
      color: #161616;
    }

    & > a {
      cursor: pointer;
      color: #0f62fe;
      text-decoration: none;
    }
  }
`

const errorMessageStyle = `
  color: #da1e28;
  max-height: 12.5rem;
  font-weight: 400;
  font-size: .75rem;
  line-height: 1.33333;
  letter-spacing: .32px;
  margin: 0.25rem 0 0;
`

const errorIconStyle = `
  right: 1rem;
  color: #da1e28;
  cursor: default;
  height: 16px;
  width: 16px;
  top: calc(50% - 10px);
  display: none;
`

const buttonStyle = `
  &:disabled { 
    box-shadow: none;
    color: #8d8d8d;
    cursor: not-allowed;
    border-color: #c6c6c6;
    background: #c6c6c6;
    opacity: 1;
  }

  &:hover {
    background-color: #0050e6;
  }

  &:focus {
    box-shadow: inset 0 0 0 1px #0f62fe,inset 0 0 0 2px #ffffff;
    border-color: #0f62fe;
  }

  &:active {
    background-color: #002d9c;
  }
  border: unset;
  background-color: #0f62fe;
  justify-content: left;
  width: 8rem;
  height: 48px;
  padding: calc(0.875rem - 3px) 63px calc(0.875rem - 3px) 15px;
`

const ctaContainer = `
    display: flex;
    align-items: center;
    padding: 1.625rem 2rem;
    width: 100%;
    display: flex;
    box-shadow: none;
    border-radius: 0;
    background-color: ${SwxTheme.palette.white};
    justify-content: flex-start;
    position: sticky;
    left: 0;
    bottom: 0;
    border-top: 0.063rem solid #c6c6c6;
    section {
      div {
        label {
          margin-top: unset !important;
        }
      }
    }
  `

const buttonPrimaryStyle = `
    min-width: 7.813rem;
    background-color: #393939;
    justify-content: left;
    border: unset;
    &:hover {
      background-color: #4C4C4C !important;
    }
    
    &:focus {
      background-color: #393939 !important;
      border-color: #0f62fe;
      box-shadow: inset 0 0 0 1px #0f62fe,inset 0 0 0 2px #f4f4f4;
    }
  
    &:active {
      background-color: #6f6f6f !important;
    }
  `

const buttonPrimaryAcceptedStyle = `
    min-width: 7.813rem;
    background-color: #393939;
    justify-content: left;
    border: unset;
    &:hover {
      background-color: #393939 !important;
    }
  
    &:focus {
      background-color: #393939 !important;
    }
  
    &:active {
      background-color: #393939 !important;
    }
  `

const buttonCancelStyle = `
    min-width: 7.75rem;
    margin-right: 0.938rem;
    background-color: ${SwxTheme.palette.white};
    justify-content: left;
    border: solid 1px ${SwxTheme.palette.black};
  `

const smallScreenButtonContainer = `
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    button {
      width: 100%;
      margin-left: 0px;
    }
    button:nth-child(1) {
      margin-top: 5px;
  `

export {
  buttonStyle,
  errorIconStyle,
  collaborateTheme,
  errorMessageStyle,
  ctaContainer,
  buttonPrimaryStyle,
  buttonCancelStyle,
  smallScreenButtonContainer,
  buttonPrimaryAcceptedStyle
}
